'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class MembersCollection
 */
var MembersCollection = function () {

  /**
   * @param {Object} locus
   * @memberof Members
   */
  function MembersCollection() {
    (0, _classCallCheck3.default)(this, MembersCollection);
    this.namespace = _constants.MEETINGS;

    this.members = {};
  }

  (0, _createClass3.default)(MembersCollection, [{
    key: 'set',
    value: function set(id, member) {
      this.members[id] = member;
    }
  }, {
    key: 'setAll',
    value: function setAll(members) {
      this.members = members;
    }

    /**
     * @param {String} id
     * @returns {Member}
     */

  }, {
    key: 'get',
    value: function get(id) {
      return this.members[id];
    }

    /**
     * @returns {Object} returns an object map of Member instances
     * @memberof MembersCollection
     */

  }, {
    key: 'getAll',
    value: function getAll() {
      return this.members;
    }
  }]);
  return MembersCollection;
}();

exports.default = MembersCollection;
//# sourceMappingURL=collection.js.map
